import { Injectable } from '@angular/core';
import { Category, ExecutiveReportService, ReportConfig } from '@vendasta/executive-report';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { PartnerService } from '../../core/partner.service';

@Injectable({ providedIn: 'root' })
export class CustomizeExecReportService {
  private enabledCategories$$: ReplaySubject<Array<Category>> = new ReplaySubject<Array<Category>>(1);
  private isSavingCategories$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private execReportSDK: ExecutiveReportService,
    private snackbarService: SnackbarService,
    private partnerService: PartnerService,
  ) {}

  getEnabledExecReportCategories(partnerId: string, marketId: string): void {
    this.execReportSDK
      .getReportConfig(partnerId, marketId)
      .subscribe((data: ReportConfig) => this.enabledCategories$$.next(data.enabledCategories));
  }

  setConfigReportCategories(partnerId: string, marketId: string, newCategories: Array<Category>): void {
    this.isSavingCategories$$.next(true);
    const market = marketId ? marketId : 'default';

    if (this.userHasWritePermissions(marketId)) {
      const config = new ReportConfig({ enabledCategories: newCategories });
      this.execReportSDK.saveReportConfig(partnerId, marketId, config).subscribe(
        () => {
          this.enabledCategories$$.next(newCategories);
          this.snackbarService.successSnack(`Applied changes to ${market} market`);
        },
        () => {
          this.isSavingCategories$$.next(false);
          this.snackbarService.errorSnack(`Failed to set configuration for ${market} market`);
        },
        () => this.isSavingCategories$$.next(false),
      );
    } else {
      this.isSavingCategories$$.next(false);
      this.snackbarService.errorSnack(`You do not have the permissions to configure ${market} market`);
    }
  }

  get enabledCategories$(): Observable<Array<Category>> {
    return this.enabledCategories$$.asObservable();
  }

  get isSavingCategories$(): Observable<boolean> {
    return this.isSavingCategories$$.asObservable();
  }

  private userHasWritePermissions(marketId: string): boolean {
    if (!this.partnerService.CanCustomizeWhitelabel) {
      return false;
    }

    return marketId && this.partnerService.MarketAccess.length > 0
      ? this.partnerService.MarketAccess.some((id) => id === marketId)
      : true;
  }
}
